import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import React from 'react';
import PropTypes from 'prop-types';
import { useAccordionListStateContext, useAccordionListDispatchContext, SET_SELECTED_ID } from 'Components/UI/TabularAccordionList/AccordionListContext';
import AccordionColumn
  from 'Components/UI/TabularAccordionList/AccordionColumn';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import StatusIndicator
  from 'Components/AdvisorApp/Viewport/ClientExperience/ClientExperienceAccordionList/StatusIndicator';
import { useColumnStyles } from './hooks';

function Accordion({
  resource, ContentCompnent, ContentProps, classes, className, accordionSummaryClasses, ...rest
}) {
  const { selectedId, schema } = useAccordionListStateContext();
  const dispatch = useAccordionListDispatchContext();
  const colStyles = useColumnStyles();
  const open = resource.id() === selectedId;
  return (
    <MuiAccordion
      square
      className={classNames(classes.root, className, {
        [classes.open]: open,
      })}
      component={Box}
      expanded={open}
      onChange={() => {
        if (open) {
          dispatch({ type: SET_SELECTED_ID });
        } else {
          dispatch({ type: SET_SELECTED_ID, id: resource.id() });
        }
      }}
      TransitionProps={{
        mountOnEnter: true, // We do this so we don't fetch resources in the content of all rendered accordions until they're opened
      }}
      {...rest}
    >
      <AccordionSummary
        classes={{
          expanded: classes.open,
          ...accordionSummaryClasses,
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <div className={classes.statusIndicator}>
          <StatusIndicator status={resource.attr('reviewStatus')} />
        </div>
        <Box display="flex" width="100%">
          {Object.entries(schema).map(([name, { ColumnComponent }]) => (
            <AccordionColumn key={`header-${name}`} className={colStyles.col}>
              <ColumnComponent attrName={name} resource={resource} />
            </AccordionColumn>
          ))}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <ContentCompnent resource={resource} {...ContentProps} />
      </AccordionDetails>
    </MuiAccordion>
  );
}

Accordion.defaultProps = {
  accordionSummaryClasses: {},
  ContentProps: {},
  className: '',
};

Accordion.propTypes = {
  accordionSummaryClasses: PropTypes.object,
  resource: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  ContentCompnent: PropTypes.object.isRequired,
  ContentProps: PropTypes.object,
};

export default withStyles(theme => ({
  root: {
    height: 'auto',
  },
  open: {
    backgroundColor: theme.palette.facet.lightGray,
  },
  statusIndicator: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 16,
    minWidth: 16,
  },
}))(Accordion);
